export default "__VITE_ASSET__BnW1grJw__"